// Shared behavior for the SAP-style "Back to Register" affordance on
// the Create Invoice pages. When these pages are opened in a new tab
// from the register's "Create Invoice" toolbar button, we close the tab
// on Back; otherwise we navigate back to the register in the same tab
// (direct-link / bookmark fallback).
export function goBackToRegister(navigate) {
  try {
    if (typeof window !== "undefined" && window.opener && !window.opener.closed) {
      window.close();
      // ``window.close()`` is a no-op in some browsers when the tab was
      // not script-opened; fall through to navigate so the user always
      // ends up on the register.
    }
  } catch (_) {
    // Cross-origin or sandboxed opener — fall through to in-tab nav.
  }
  navigate("/invoices/new");
}
